import React from "react";
import { Modal, Button } from "react-bootstrap";

const Alert_modal = ({
  show,             // boolean -> controla la visibilidad del modal
  onHide,           // función -> se ejecuta al cerrar el modal
  title,            // string -> encabezado del modal
  message,          // string -> contenido o mensaje
  variantButton,    // string -> color del botón (primary, success, danger, etc.)
  textButton        // string -> texto del botón
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
   

      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer className ="justify-content-center">
        <Button variant={variantButton} onClick={onHide}>
          {textButton}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Alert_modal;
